import { render, staticRenderFns } from "./FieldCustomerName.vue?vue&type=template&id=59660187&"
import script from "./FieldCustomerName.vue?vue&type=script&lang=js&"
export * from "./FieldCustomerName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports